/**
 * Product details
 */
 var component_product_details = function(args) {

  var main_element = args.main_element;
  var tablist = main_element.querySelector('[role="tablist"]');
  var tabs = main_element.querySelectorAll('[role="tab"]');
  var panels = main_element.querySelectorAll('[role="tabpanel"]');

  // validate
  if (!main_element || !tablist || !tabs.item(0) || !panels.item(0)) {
    console.log(
      'Missing arguments for product details component',
      '\n' , 'main_element: ', main_element,
      '\n' , 'tablist: ', tablist,
      '\n' , 'tabs: ', tabs,
      '\n' , 'panels: ', panels
    );
    return;
  }

  // use accessible tabs component
  component_accessible_tabs({
    tablist: tablist,
    tabs: tabs,
    panels: panels,
  });

  // make the call chainable
  return this;
};
